export default function singleActiveNotebookId(
  search = window.location.search
) {
  const params = new URLSearchParams(search);
  const ids = params
    .getAll('notebook_ids[]')
    .concat(params.getAll('notebook_ids'))
    .filter(Boolean);

  const unique = [...new Set(ids)];

  if (unique.length !== 1) {
    return undefined;
  }

  return unique[0];
}
